import { render, staticRenderFns } from "./SubscriptionAnomalyList.vue?vue&type=template&id=0aca1a4c"
import script from "./SubscriptionAnomalyList.vue?vue&type=script&lang=js"
export * from "./SubscriptionAnomalyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports